import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner";
import { constants } from "../../../firebase/firestoreNameSpaces";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import OrdersCard from "./ordersCard";

class OrdersTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      STATUS_COMBINATION: null, //For Filter Options  object
      selectedStatus: null, //Option Selected  array,
      ordertype: "forward",
    };

    this.handleAcceptedOrders = this.handleAcceptedOrders.bind(this);
    this.handleScheduledOrders = this.handleScheduledOrders.bind(this);
    this.handleCompletedOrders = this.handleCompletedOrders.bind(this);
    this.handleCancelledOrders = this.handleCancelledOrders.bind(this);
  }

  componentDidMount() {
    let sc = constants.FORWARD_SHIPMENT.STATUS_COMBINATION;

    this.setState({
      STATUS_COMBINATION: sc,
      selectedStatus: sc[Object.keys(sc)[0]],
      ordertype: "forward",
    });
    this.props.onFetchCompletedOrders();
    this.props.resetLoadMore();

    // this.props.onFetchOngoingOrders();
    // this.handleAcceptedOrders();
    // this.handleScheduledOrders();
  }

  // componentDidUpdate = (prevProps,prevState)=>{
  //   if(this.state.STATUS_COMBINATION!=prevState.STATUS_COMBINATION){
  //     this.getStatusOptions()
  //   }
  // }
  handleAcceptedOrders(e) {
    // e.preventDefault();
    this.props.resetLoadMore();
    this.props.onFetchAcceptedOrders();
  }

  handleScheduledOrders(e) {
    // e.preventDefault();
    this.props.resetLoadMore();
    this.props.onFetchScheduledOrders();
  }

  handleCompletedOrders(e) {
    document.getElementById(
      `${this.state.ordertype}select`
    ).children[0].selected = true;
    let sc = constants.FORWARD_SHIPMENT.STATUS_COMBINATION;
    this.setState({
      STATUS_COMBINATION: sc,
      selectedStatus: Object.keys(sc)[0],
      ordertype: "forward",
    });

    // e.preventDefault();
    this.props.resetLoadMore();
    this.props.onFetchCompletedOrders();
  }

  handleCancelledOrders(e) {
    document.getElementById(
      `${this.state.ordertype}select`
    ).children[0].selected = true;
    let sc = constants.BACKWARD_SHIPMENT.STATUS_COMBINATION;
    this.setState({
      STATUS_COMBINATION: sc,
      selectedStatus: Object.keys(sc)[0],
      ordertype: "reverse",
    });

    // e.preventDefault();
    this.props.resetLoadMore();
    this.props.onFetchCancelledOrders();
  }

  setStatusFilter = (ordertype, option) => {
    // console.log(ordertype,option)
    if (ordertype == "forward") {
      let sc = constants.FORWARD_SHIPMENT.STATUS_COMBINATION[option];
      this.setState({ selectedStatus: sc });
      this.props.onFetchCompletedOrders(sc);
    } else if (ordertype == "reverse") {
      let sc = constants.BACKWARD_SHIPMENT.STATUS_COMBINATION[option];
      this.props.onFetchCancelledOrders(sc);
      this.setState({ selectedStatus: sc });
    } else {
      return alert("Wrong Filter");
    }
  };

  getStatusOptions = () => {
    let STATUS_COMBINATION = this.state.STATUS_COMBINATION;
    let sc = [];
    if (STATUS_COMBINATION) {
      Object.keys(STATUS_COMBINATION).map((option, index) => {
        if (index == 0) {
          sc.push(
            <option value={option} selected={true}>
              {option}
            </option>
          );
        } else {
          sc.push(<option value={option}>{option}</option>);
        }
      });
      return sc;
    } else {
      return null;
    }
  };
  render() {
    let STATUS_COMBINATION = this.state.STATUS_COMBINATION;
    let orderType = this.state.ordertype;
    // let ongoingOrders = this.props.ongoingOrders.map((order, index) => (
    //   <OrdersCard
    //     key={index}
    //     orders={order}
    //     display={"d-none"}
    //     btnDisplay={"d-inline"}
    //     uniqueModal={"ongoing"}
    //     payBtnDisplay={"d-none"}
    //     refundBtnDisplay={"d-none"}
    //   />
    // ));

    // let scheduledOrders = this.props.scheduledOrders.map((order, index) => (
    //   <OrdersCard
    //     key={index}
    //     orders={order}
    //     display={"d-none"}
    //     btnDisplay={"d-inline"}
    //     uniqueModal={"scheduled"}
    //     payBtnDisplay={"d-none"}
    //     refundBtnDisplay={"d-none"}
    //   />
    // ));

    // let acceptedOrders = this.props.acceptedOrders.map((order, index) => (
    //   <OrdersCard
    //     key={index}
    //     orders={order}
    //     btnDisplay={"d-inline"}
    //     uniqueModal={"accepted"}
    //     payBtnDisplay={"d-none"}
    //     refundBtnDisplay={"d-none"}

    //   />
    // ));

    let completedOrders = this.props.completedOrders.map((order, index) => (
      <React.Fragment>
        {order.products.map((product, index) => (
          <OrdersCard
            key={index}
            orders={order}
            product={product}
            productIndex={index}
            btnDisplay={"d-none"}
            uniqueModal={"completed"}
            payBtnDisplay={"d-block"}
            refundBtnDisplay={"d-block"}
            orderFilterObj={constants.FORWARD_SHIPMENT.STATUS_COMBINATION}
          />
        ))}

        {this.props.completedOrders.length - 1 == index &&
        !this.props.leadsexhausted ? (
          <div style={{ position: "absolute", left: "40%" }}>
            <button
              className="btn btn-sm btn-success"
              onClick={() =>
                this.props.onLoadMoreCompletedOrders(
                  this.props.leadsexhausted,
                  this.props.lastDoc,
                  this.props.limit,
                  this.state.selectedStatus
                )
              }
            >
              Load More
            </button>
          </div>
        ) : null}
      </React.Fragment>
    ));

    let cancelledOrders = this.props.cancelledOrders.map((order, index) => (
      <React.Fragment>
        {order.products.map((product, index) => (
          <OrdersCard
            key={index}
            orders={order}
            product={product}
            productIndex={index}
            display={"d-none"}
            btnDisplay={"d-none"}
            uniqueModal={"cancelled"}
            payBtnDisplay={"d-none"}
            refundBtnDisplay={"d-block"}
            productIndex={index}
            orderFilterObj={constants.BACKWARD_SHIPMENT.STATUS_COMBINATION}
          />
        ))}
        {this.props.cancelledOrders.length - 1 == index &&
        !this.props.leadsexhausted ? (
          <div style={{ position: "absolute", left: "40%" }}>
            <button
              className="btn btn-sm btn-success"
              onClick={() =>
                this.props.onLoadCancelledOrders(
                  this.props.leadsexhausted,
                  this.props.lastDoc,
                  this.props.limit,
                  this.state.selectedStatus
                )
              }
            >
              Load More
            </button>
          </div>
        ) : null}
      </React.Fragment>
    ));

    return (
      <div className="mx-5">
        <h3 className="text-center mt-2">Orders Management</h3>
        <div className="m-2">
          <ul
            className="nav nav-tabs"
            style={{ backgroundColor: "lightgoldenrodyellow" }}
            id="myTab"
            role="tablist"
          >
            {/* <li className="nav-item">
              <a
                className="nav-link active"
                id="ongoing-tab"
                data-toggle="tab"
                href="#ongoing"
                role="tab"
                aria-controls="ongoing"
                aria-selected="true"
              >
                New Orders{" "}
                <span class="badge badge-light" style={{ fontSize: "18px" }}>
                  {this.props.ongoingOrders.length}
                </span>
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                id="accepted-tab"
                data-toggle="tab"
                href="#accepted"
                role="tab"
                aria-controls="accepted"
                aria-selected="false"
                onClick={this.handleAcceptedOrders}
              >
                Accepted Orders
                <span class="badge badge-light" style={{ fontSize: "18px" }}>
                  {this.props.acceptedOrders.length}
                </span>
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                id="scheduled-tab"
                data-toggle="tab"
                href="#scheduled"
                role="tab"
                aria-controls="scheduled"
                aria-selected="false"
                onClick={this.handleScheduledOrders}
              >
                Scheduled Orders{" "}
                <span class="badge badge-light" style={{ fontSize: "18px" }}>
                  {this.props.scheduledOrders.length}
                </span>
              </a>
            </li> */}
            <li className="nav-item">
              <a
                className="nav-link active"
                id="completed-tab"
                data-toggle="tab"
                href="#completed"
                role="tab"
                aria-controls="completed"
                aria-selected="true"
                onClick={this.handleCompletedOrders}
              >
                Forward Orders{" "}
                {/* {this.props.completedOrders.length ? (
                  <span class="badge badge-light" style={{ fontSize: "18px" }}>
                    {this.props.completedOrders.length}
                  </span>
                ) : (
                  ""
                )} */}
              </a>
            </li>

            <li className="nav-item">
              <a
                className="nav-link"
                id="cancelled-tab"
                data-toggle="tab"
                href="#cancelled"
                role="tab"
                aria-controls="cancelled"
                aria-selected="false"
                onClick={this.handleCancelledOrders}
              >
                Reverse Orders{" "}
                {/* {this.props.cancelledOrders.length ? (
                  <span class="badge badge-light" style={{ fontSize: "18px" }}>
                    {this.props.cancelledOrders.length}
                  </span>
                ) : (
                  ""
                )} */}
              </a>
            </li>
            <li className="float-right">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label className="input-group-text">Filter</label>
                </div>

                <select
                  className="custom-select"
                  onChange={(e) =>
                    this.setStatusFilter(this.state.ordertype, e.target.value)
                  }
                  id={`${orderType}select`}
                >
                  {/* <option selected>Choose...</option> */}

                  {/* {
                       STATUS_COMBINATION&&( Object.keys(STATUS_COMBINATION).map((option,index)=>(
                         
                        <option value={option} selected={index==0?true:false} >{option}</option>

                       ))   )
                    } */}

                  {this.getStatusOptions()}
                </select>
              </div>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            {/* <div
              className="tab-pane fade show active"
              id="ongoing"
              role="tabpanel"
              aria-labelledby="ongoing-tab"
            >
              {this.props.ongoingOrdersLoading ? (
                <Spinner />
              ) : (
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Receipt #</th>
                      <th scope="col">Booking Date-Time</th>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Contact #</th>
                      <th scope="col">Details</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>{ongoingOrders}</tbody>
                </table>
              )}
            </div>
            <div
              className="tab-pane fade"
              id="accepted"
              role="tabpanel"
              aria-labelledby="accepted-tab"
            >
              {this.props.acceptedOrdersLoading ? (
                <Spinner />
              ) : (
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Receipt #</th>
                      <th scope="col">Booking Date-Time</th>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Contact #</th>
                      <th scope="col">Details</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>{acceptedOrders}</tbody>
                </table>
              )}
            </div>
            <div
              className="tab-pane fade"
              id="scheduled"
              role="tabpanel"
              aria-labelledby="scheduled-tab"
            >
              {this.props.scheduledOrdersLoading ? (
                <Spinner />
              ) : (
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Receipt #</th>
                      <th scope="col">Booking Date-Time</th>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Contact #</th>
                      <th scope="col">Details</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>{scheduledOrders}</tbody>
                </table>
              )}
            </div> */}
            <div
              className="tab-pane fade show active"
              id="completed"
              role="tabpanel"
              aria-labelledby="completed-tab"
            >
              {this.props.completedOrdersLoading ? (
                <Spinner />
              ) : (
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Receipt #</th>
                      <th scope="col">Waybill</th>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Contact #</th>
                      <th scope="col">Details</th>
                      <th scope="col">Actions</th>

                      {/* <th scope="col">Filter</th> */}
                    </tr>
                  </thead>
                  <tbody>{completedOrders}</tbody>
                </table>
              )}
            </div>
            <div
              className="tab-pane fade"
              id="cancelled"
              role="tabpanel"
              aria-labelledby="cancelled-tab"
            >
              {this.props.cancelledOrdersLoading ? (
                <Spinner />
              ) : (
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Receipt #</th>
                      <th scope="col">Waybill</th>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Contact #</th>
                      <th scope="col">Details</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>{cancelledOrders}</tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ongoingOrders: state.orders.ongoingOrders,
    acceptedOrders: state.orders.acceptedOrders,
    scheduledOrders: state.orders.scheduledOrders,
    completedOrders: state.orders.completedOrders,
    cancelledOrders: state.orders.cancelledOrders,
    ongoingOrdersLoading: state.orders.ongoingOrdersLoading,
    acceptedOrdersLoading: state.orders.acceptedOrdersLoading,
    scheduledOrdersLoading: state.orders.scheduledOrdersLoading,
    completedOrdersLoading: state.orders.completedOrdersLoading,
    cancelledOrdersLoading: state.orders.cancelledOrdersLoading,
    leadsexhausted: state.orders.leadsexhausted,
    lastDoc: state.orders.lastDoc,
    limit: state.orders.limit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchOngoingOrders: () => dispatch(actions.onFetchOngoingOrders()),
    onFetchAcceptedOrders: () => dispatch(actions.onFetchAcceptedOrders()),
    onFetchScheduledOrders: () => dispatch(actions.onFetchScheduledOrders()),
    onFetchCompletedOrders: (sc) =>
      dispatch(actions.onFetchCompletedOrders(sc)),
    onFetchCancelledOrders: (sc) =>
      dispatch(actions.onFetchCancelledOrders(sc)),
    onLoadMoreCompletedOrders: (leadsexhausted, lastDoc, limit, sc) =>
      dispatch(
        actions.onLoadMoreCompletedOrders(leadsexhausted, lastDoc, limit, sc)
      ),
    onLoadCancelledOrders: (leadsexhausted, lastDoc, limit, sc) =>
      dispatch(
        actions.onLoadCancelledOrders(leadsexhausted, lastDoc, limit, sc)
      ),
    resetLoadMore: () => dispatch(actions.resetLoadMore()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(OrdersTabs, Axios));
